import { IHttpApi } from '@cian/http-api';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  TCianApiSiteV1GetDeveloperInfoResponse,
  fetchCianApiSiteV1GetDeveloperInfo,
} from 'shared/repositories/monolith-python/cian-api/site/v1/get-developer-info';
import { IDeveloperInfoHeaderSchema } from 'shared/repositories/monolith-python/entities/schemas/DeveloperInfoHeaderSchema';
import { extractUndefined } from 'shared/utils/extractUndefined';

export type IDeveloperInfo = IDeveloperInfoHeaderSchema;

type GetDeveloperInfoOptions = {
  httpApi: IHttpApi;
  subdomain: string;
  id: number;
};

export function getDeveloperInfo({
  httpApi,
  subdomain,
  id,
}: GetDeveloperInfoOptions): Promise<IDeveloperInfoHeaderSchema | null> {
  return fetchCianApiSiteV1GetDeveloperInfo<
    TCianApiSiteV1GetDeveloperInfoResponse,
    TCianApiSiteV1GetDeveloperInfoResponse,
    TCianApiSiteV1GetDeveloperInfoResponse
  >({
    httpApi,
    parameters: {
      developerId: id,
    },
    config: {
      subdomain,
    },
  })
    .then(({ response, statusCode }) => {
      switch (statusCode) {
        case 200:
          return extractUndefined(response.data.data);
        case 400:
        case 404:
          throw new HttpBadStatusCodeError({
            statusCode,
            domain: 'src/shared/api/developers.ts',
          });
      }
    })
    .catch(ex => {
      if (HttpBadStatusCodeError.is(ex)) {
        if (ex.statusCode === 404) {
          return null;
        }
      }

      throw ex;
    });
}
